import { render, staticRenderFns } from "./AutomacaoWizardPasso.vue?vue&type=template&id=a650e83a"
import script from "./AutomacaoWizardPasso.vue?vue&type=script&lang=js"
export * from "./AutomacaoWizardPasso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports